import type { ComponentProps } from 'react';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import { tss } from 'tss-react/mui';
import { getThemeColor } from '@/muiTheme';

type CommentIconSize = 'small' | 'large';

/**
 * Comment icon only supports 2 different sizes as opposed to the sizes value of the icon. The color relies on the value of the `count`.
 * Set the color to disable/gray if the count is zero. If greater to zero, then set it to primary.
 */
export default function CommentIcon({
    count = 0,
    size = 'large',
    ...rootProps
}: Omit<ComponentProps<typeof ChatBubbleIcon>, 'fontSize'> & {
    count?: number;
    size?: CommentIconSize;
}) {
    const { classes, cx } = useCommentIconStyles();
    const iconSize = size === 'large' ? 'large' : 'medium';
    return (
        <div className={classes.commentIconContainer}>
            <span className={cx(classes.count, classes[`count__${size}`])}>
                {count}
            </span>
            <ChatBubbleIcon
                color={count > 0 ? 'primary' : 'disabled'}
                fontSize={iconSize}
                {...rootProps}
            />
        </div>
    );
}

const useCommentIconStyles = tss.create(({ theme }) => ({
    commentIconContainer: {
        position: 'relative',
    },
    count: {
        color: getThemeColor(theme)('white'),
        fontFamily: 'AvertaStandard',
        fontWeight: 600,
        position: 'absolute',
        top: '40%',
        left: '50%',
        transform: `translate(-50%, -50%)`,
    },
    count__small: {
        fontSize: 10,
    },
    count__large: {
        fontSize: 14,
    },
}));
